import { isDeepEqual } from 'utils/object'

export const getFilterInitState =
  (query = {}) =>
  (acc, filterConfig) => ({
    ...acc,
    [filterConfig.key]: query[filterConfig.key] || filterConfig.defaultValue,
  })

export const getFilterQuery = (filter, filtersConfigs) =>
  filtersConfigs.reduce(
    (acc, filterConfig) => ({ ...acc, ...filterConfig.getQuery(filter) }),
    {},
  )

// Compared by value: array defaults such as `department: []` are a new array per config
export const getIsFilteredResults = (filtersConfigs, filter) =>
  filtersConfigs.some(conf => !isDeepEqual(filter[conf.key], conf.defaultValue))

export const getDepartmentValueFromQuery = (query, departments) => {
  if (query.department == null) {
    return []
  }

  const queryDepartments = Array.isArray(query.department)
    ? query.department
    : [query.department]

  // A department id in the URL may no longer exist, e.g. from an old bookmark
  return queryDepartments
    .map(id => departments?.find(resp => resp.id === Number(id)))
    .filter(Boolean)
    .map(dep => ({ value: dep.id, label: dep.name }))
}
